//--------------------| Objeto vacio  |--------------------
export let clienteVacio = {
    id: null,
    nombreRazon: "",
    apellidos: "",
    rfc:"",
    email:"",
    idEstatus: 1,
    esFisica:true, 
    direccion : {
        calle: "",
        colonia:"",
        cp:"",
        ciudad:"",
        numeroExt:"",
        numeroInt:"",
        delegacionMunicipio:""
    }  
}